import React, { Component } from "react";
import { Button,Form,Icon,Grid } from "tabler-react";
import { GetRoles } from "../../herramientas/JWT";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
class  RolesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {       nombre:      "",
                         descripcion: "",                        
                         accion: this.props.accion, //'nuevo'// modificar, nuevo
                         crudbutonEnable: true, // Se desabilita cuando se hace click
                  };
    this.rolObj={ "nombre": "", "descripcion": "" }
  }
  componentDidMount =() => {
    if(this.state.accion !== 'nuevo'){
      this.setState({nombre: this.props.elemento.nombre});
      this.setState({descripcion: this.props.elemento.descripcion});
      this.rolObj= this.props.elemento;
    }
  }
  enableSave =() =>{
    if(this.state.nombre.length&& this.state.descripcion.length )
      return false;
    else
      return true
  }
  changeNombre =(event) => {
    this.setState({nombre: event.target.value});
    this.rolObj.nombre= event.target.value;
  }
  changeDescripcion = (event) =>{
    this.setState({descripcion: event.target.value});
    this.rolObj.descripcion= event.target.value;
  }

  delete() {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, "delete", "", this.rolObj.id).then((returnVal) => {
      window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  save(metodo= "post") {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, metodo, this.rolObj, "").then((returnVal) => {
      //window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  

  render(){
    return (
      <div>
        { this.state.accion === "modificar" ? <h1> { this.props.elemento.nombre } </h1> : null }
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
           <Grid.Row>
             <Grid.Col md={9} lg={9}>
              <Form.Group label="Nombre">
                <Form.Input name="nombre" type="text" value={ this.state.nombre } onChange={this.changeNombre} maxlength="30" />
              </Form.Group>
             </Grid.Col>
             <Grid.Col md={6} lg={6}>
              <Form.Group label="Descripcion">
               <Form.Textarea name="descripcion" type="text" value={ this.state.descripcion } onChange={this.changeDescripcion} maxlength="255"/>
              </Form.Group>
             </Grid.Col>
           </Grid.Row>
          </Grid.Col>
        </Grid.Row>
        <div className="float-right">
          {GetRoles().includes("root") ?
            <span class="badge">
                <Button target="_blank" size="sm" RootComponent="a" color="primary" disabled= { this.enableSave() || !this.state.crudbutonEnable }
                  onClick= { this.state.accion === "modificar" ? () => this.save("put") : () => this.save("post") }
                >
                  <span class="badge"><Icon link={true} name="save" />Guardar</span>
                </Button>
            </span>
          :null}
          { GetRoles().includes("root")  ?
            <span class="badge">
              <Button target="_blank" size="sm" RootComponent="a" color="primary"
                onClick= { () => this.delete() } disabled={!this.state.crudbutonEnable}
              >
                <span class="badge"><Icon link={true} name="trash" />Borrar</span>
              </Button>
            </span>
          :
          null
          }
        </div>
      </div>
    );
  }
}
export default RolesForm;
